@if (element.data | withLoading | async; as widget) { @if (!widget.loading && (hasAtLeastOneXdr(widget) || isLcoCompany)) {
<mat-grid-list
    class="m-t-15"
    cols="1"
    rowHeight="70px"
    id="xdr_license_container"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container no-padding justify-center">
            <div class="widget-full-width-height-2">
                <ng-container>
                    @if (((widget.data?.data && !isEmptyObject(widget.data?.data))) && !widget.loading) {
                    <div class="item indicator">
                        <div class="item-content d-flex-center flex-direction-row">
                            <app-mdr-title
                                fontSize="16"
                                class="item--title m-l-20 d-flex widget-title"
                            >
                                <span class="m-t-5">{{ element.title }}</span>
                            </app-mdr-title>
                            <div class="d-flex m-l-30 checks-container">
                                @if (isLcoCompany) {
                                <div class="check-container">
                                    <span class="m-r-2"><b>MDR</b> Foundations</span>
                                    <span class="ds-icon-validation checked-icon m-l-10 m-r-10 fs-25 item--value"></span>
                                </div>
                                } @for (check of returnArrayOfKeys(widget.data.data); track check; let i = $index) { @if
                                (widget.data.data[check]) {
                                <div
                                    id="xdr_{{ check }}_indicator"
                                    class="check-container"
                                    [ngClass]="{
                                        'no-border': i === returnArrayOfKeys(widget.data.data).length - 1,
                                        unactivated: !widget.data.data[check]
                                    }"
                                >
                                    <span
                                        [ngClass]="getXdrIcon(check)"
                                        class="fs-22 m-r-2"
                                    ></span>
                                    {{ getXdrName(check) }}
                                    @if (widget.data.data[check]) {
                                    <span class="ds-icon-validation checked-icon m-l-10 m-r-10 fs-25 item--value"> </span>
                                    }
                                </div>
                                } @if (!widget.data.data[check]) {
                                <div
                                    class="check-container unactivated"
                                    mat-raised-button
                                    #tooltip="matTooltip"
                                    matTooltip="You don't have this add-on yet."
                                    [matTooltipPosition]="'below'"
                                    matTooltipHideDelay="100"
                                    [ngClass]="{ 'no-border': i === widget.data.data.length - 1 }"
                                >
                                    <span
                                        [ngClass]="getXdrIcon(check)"
                                        class="fs-22 m-r-2"
                                    ></span>
                                    {{ getXdrName(check) }}
                                    @if (widget.data.data[check]) {
                                    <span class="ds-icon-validation checked-icon m-l-10 m-r-10 fs-25 item--value"> </span>
                                    }
                                </div>
                                } }
                            </div>
                        </div>
                    </div>
                    } @if ((widget.data?.data && isEmptyObject(widget.data?.data) && !widget.loading) || (widget.error && !widget.loading))
                    {
                    <div class="item indicator">
                        <div class="item-content d-flex-center flex-direction-row">
                            <app-mdr-title
                                fontSize="16"
                                class="item--title m-l-20 d-flex widget-title"
                            >
                                <span>{{ element.title }}</span>
                            </app-mdr-title>
                            <div class="d-flex m-l-30 checks-container">
                                @if (isLcoCompany) {
                                <div class="check-container">
                                    <span class="m-r-2"><b>MDR</b> Foundations</span>
                                    <span class="ds-icon-validation checked-icon m-l-10 m-r-10 fs-25 item--value"></span>
                                </div>
                                } @for (check of returnArrayOfKeys(defaultEmptyValue.xdr); track check; let i = $index) { @if
                                (!defaultEmptyValue.xdr[check]) {
                                <div
                                    class="check-container grey-text"
                                    mat-raised-button
                                    #tooltip="matTooltip"
                                    matTooltip="Error on loading data"
                                    [matTooltipPosition]="'below'"
                                    matTooltipHideDelay="100"
                                    [ngClass]="{ 'no-border': i === returnArrayOfKeys(defaultEmptyValue.xdr).length - 1 }"
                                >
                                    <span
                                        [ngClass]="getXdrIcon(check)"
                                        class="fs-22 m-r-2"
                                    ></span>
                                    {{ getXdrName(check) }}
                                    <span class="fs-22 ds-icon-notification_negative m-r-10 m-l-10"></span>
                                </div>
                                } }
                            </div>
                        </div>
                    </div>
                    } @if (widget.loading) {
                    <div class="item">
                        <div class="item-content d-flex-center justify-center flex-direction-column">
                            <app-mdr-title
                                fontSize="16"
                                class="item--title d-flex widget-title"
                            >
                                <span>{{ element.title }}</span>
                            </app-mdr-title>
                        </div>
                    </div>
                    <app-mdr-loader
                        [ngClass]="widget.loading ? 'widget-empty' : 'widget-loading'"
                        class="center-loader w-40-percent"
                        [rows]="1"
                        [columns]="1"
                    ></app-mdr-loader>
                    }
                </ng-container>
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} }
